import { useMutation } from '@tanstack/react-query';

import { privacyRequestsApi } from '../api/privacy-requests-api';

function saveJson(filename: string, data: unknown) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/**
 * Fetched through the API client and saved from memory: a plain link to the endpoint would not
 * send the client header the cookie session requires (ADR 0004). A 409 (not ready) is toasted by
 * the global mutation cache.
 */
export function useDownloadPrivacyExport(storeId: string) {
  return useMutation({
    mutationFn: async (id: string) => {
      const bundle = await privacyRequestsApi.exportBundle(storeId, id);
      saveJson(`privacy-export-${id}.json`, bundle);
    },
  });
}
